import { observer } from "mobx-react-lite";
import { Badge, Button, Progress, Row, Col } from "antd";
import { initials } from "../../utils/dashboard";
import { useState, useEffect, useMemo } from "react";
import { useUserState } from "./UserState";
import { PushpinOutlined, PushpinFilled } from "@ant-design/icons";
import TimeAgo from "./TimeAgo";
import Metric from "./Metric";
import "./UserCircle.css";
import MetricBar from "./MetricBar";
import moment from "moment";

function UserCircle({
  dashboardStore,
  orgDashboardStore,
  userCode,
  pinned,
  profileSelected,
  expanded,
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const togglePushPin = async (e) => {
    const newState = !pinned;
    orgDashboardStore.setPinned(userCode, newState);
    e.stopPropagation();
    e.preventDefault();
  };

  const {
    heartRate,
    hrv,
    motion,
    color,
    alertLabel,
    introspection,
    progress,
    colorForHeartRate,
    className,
    level,
  } = useUserState(
    orgDashboardStore,
    dashboardStore,
    userCode,
    expanded,
    pinned
  );
  return (
    <>
      <div className={className} onClick={() => profileSelected(userCode)}>
        {level <= 2 && (
          <Button
            type="text"
            size="small"
            style={{ float: "right", marginRight: "-10px", color: "#565656" }}
            onClick={() => {
              togglePushPin();
            }}
          >
            {pinned ? <PushpinFilled /> : <PushpinOutlined />}
          </Button>
        )}
        {level === 1 && (
          <div>
            <div className="UserCircle__name_container">
              <div className="UserCircle__name">{userCode}</div>
              <Badge
                className="UserCircle__alert_badge"
                status={
                  color === "green"
                    ? "success"
                    : color === "yellow"
                    ? "warning"
                    : color === "red"
                    ? "danger"
                    : "inactive"
                }
                text={alertLabel}
              />
            </div>
            <MetricBar
              heartRate={heartRate}
              hrv={hrv}
              motion={motion}
              orgDashboardStore={orgDashboardStore}
              userCode={userCode}
            ></MetricBar>
            <div className="UserCircle__ago">
              <TimeAgo
                orgDashboardStore={orgDashboardStore}
                userCode={userCode}
              ></TimeAgo>
            </div>
          </div>
        )}
        {level === 2 && (
          <div className="UserCircle__level2">
            <div className="UserCircle__name_container">
              <div className="UserCircle__name">{userCode}</div>
            </div>
            <div className="UserCircle__metric_container">
              <Metric
                label="Heart"
                unit="bpm"
                value={heartRate?.value}
                color={colorForHeartRate}
              ></Metric>
            </div>
          </div>
        )}
        {level === 3 && (
          <div className="UserCircle__level3">
            <div className="UserCircle__name_container">
              <div className="UserCircle__name">{initials(userCode)}</div>
            </div>
          </div>
        )}
        {level === 4 && (
          <div className="UserCircle__level4">
            <div className="UserCircle__name_container">
              <div className="UserCircle__name">{initials(userCode)}</div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default observer(UserCircle);
